import { useScene } from '../../../../../context/sceneContext';
import { ComboInput } from '../../../baseInputs/ComboInput';
import { BackgroundInput } from './BackgroundInput';
import { BorderInput } from './BorderInput';
import { RadiusInput } from './RadiusInput';
import { ShadowInput } from './ShadowInput';

export const ContainerComboInput = () => {
  const scene = useScene();

  const data = scene.getSelectedElementsData({
    background: undefined,
    backgroundColor: undefined,
    borderRadius: undefined,

    borderWidth: undefined,
    borderStyle: undefined,
    borderColor: undefined,

    borderTopWidth: undefined,
    borderTopStyle: undefined,
    borderTopColor: undefined,

    borderBottomWidth: undefined,
    borderBottomStyle: undefined,
    borderBottomColor: undefined,

    borderLeftWidth: undefined,
    borderLeftStyle: undefined,
    borderLeftColor: undefined,

    borderRightWidth: undefined,
    borderRightStyle: undefined,
    borderRightColor: undefined,

    boxShadow: undefined,
  });

  const updateData = (props: { [key: string]: any }) =>
    scene.updateSelectedElementsData(props, undefined, 'containerComboInput');

  return (
    <ComboInput
      label="Container"
      inputs={[
        {
          name: 'Background',
          children: (
            <BackgroundInput
              value={data.background === undefined ? data.backgroundColor : data.background}
              onChange={(newValue) =>
                updateData({
                  background: newValue,
                  backgroundColor: undefined,
                })
              }
            />
          ),
          isVisible: data.background !== undefined || data.backgroundColor !== undefined,
          onAdd: () =>
            updateData({
              background: '#adadad',
              backgroundColor: undefined,
            }),
          onRemove: () =>
            updateData({
              background: undefined,
              backgroundColor: undefined,
            }),
        },
        {
          name: 'Corner Radius',
          children: (
            <RadiusInput value={data.borderRadius} onChange={(newValue) => updateData({ borderRadius: newValue })} />
          ),
          isVisible: data.borderRadius !== undefined,
          onAdd: () => updateData({ borderRadius: '20px' }),
          onRemove: () => updateData({ borderRadius: undefined }),
        },
        {
          name: 'Border',
          children: (
            <BorderInput
              data={{
                borderWidth: data.borderWidth,
                borderStyle: data.borderStyle,
                borderColor: data.borderColor,

                borderTopWidth: data.borderTopWidth,
                borderTopStyle: data.borderTopStyle,
                borderTopColor: data.borderTopColor,

                borderBottomWidth: data.borderBottomWidth,
                borderBottomStyle: data.borderBottomStyle,
                borderBottomColor: data.borderBottomColor,

                borderLeftWidth: data.borderLeftWidth,
                borderLeftStyle: data.borderLeftStyle,
                borderLeftColor: data.borderLeftColor,

                borderRightWidth: data.borderRightWidth,
                borderRightStyle: data.borderRightStyle,
                borderRightColor: data.borderRightColor,
              }}
              updateData={updateData}
            />
          ),
          isVisible: data.borderWidth !== undefined || !(data.borderTopWidth === undefined && data.borderBottomWidth === undefined && data.borderLeftWidth === undefined && data.borderRightWidth === undefined),
          onAdd: () =>
            updateData({
              borderTopWidth: '1px',
              borderTopStyle: 'solid',
              borderTopColor: '#000000',

              borderBottomWidth: '1px',
              borderBottomStyle: 'solid',
              borderBottomColor: '#000000',

              borderLeftWidth: '1px',
              borderLeftStyle: 'solid',
              borderLeftColor: '#000000',

              borderRightWidth: '1px',
              borderRightStyle: 'solid',
              borderRightColor: '#000000',
            }),
          onRemove: () =>
            updateData({
              borderWidth: undefined,
              borderStyle: undefined,
              borderColor: undefined,

              borderTopWidth: undefined,
              borderTopStyle: undefined,
              borderTopColor: undefined,

              borderBottomWidth: undefined,
              borderBottomStyle: undefined,
              borderBottomColor: undefined,

              borderLeftWidth: undefined,
              borderLeftStyle: undefined,
              borderLeftColor: undefined,

              borderRightWidth: undefined,
              borderRightStyle: undefined,
              borderRightColor: undefined,
            }),
        },
        {
          name: 'Shadow',
          children: <ShadowInput value={data.boxShadow} onChange={(newValue) => updateData({ boxShadow: newValue })} />,
          isVisible: data.boxShadow !== undefined,
          onAdd: () => updateData({ boxShadow: '0px 0px 10px 2px #000000' }),
          onRemove: () => updateData({ boxShadow: undefined }),
        },
      ]}
    />
  );
};
